import { useLang } from '../i18n';

const INSTAGRAM_URL = 'https://www.instagram.com/supermufflerinc?igsh=NTc4MTIwNjQ2YQ%3D%3D';
const FACEBOOK_URL = 'https://www.facebook.com/supermufflerinc';
const TIKTOK_URL = 'https://www.tiktok.com/@supermuffler';
const GOOGLE_URL = 'https://share.google/nqjEWobwrklyMOAn0';

function InstagramIcon() {
  return (
    <div style={{ width: 44, height: 44, borderRadius: 12, background: 'linear-gradient(135deg, #f58529, #dd2a7b, #8134af, #515bd4)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
      </svg>
    </div>
  );
}

function FacebookIcon() {
  return (
    <div style={{ width: 44, height: 44, borderRadius: 12, background: '#1877F2', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
      </svg>
    </div>
  );
}

function GoogleIcon() {
  return (
    <div style={{ width: 44, height: 44, borderRadius: 12, background: '#EA4335', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
      </svg>
    </div>
  );
}

function TikTokIcon() {
  return (
    <div style={{ width: 44, height: 44, borderRadius: 12, background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.21 8.21 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.14z"/>
      </svg>
    </div>
  );
}

function StarIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  );
}

function ExternalIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 4 }}>
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
    </svg>
  );
}

const socials = [
  {
    icon: InstagramIcon,
    titleKey: 'socialIgTitle',
    handleKey: 'socialIgHandle',
    descKey: 'socialIgDesc',
    ctaKey: 'socialIgCta',
    url: INSTAGRAM_URL,
  },
  {
    icon: FacebookIcon,
    titleKey: 'socialFbTitle',
    handleKey: 'socialFbHandle',
    descKey: 'socialFbDesc',
    ctaKey: 'socialFbCta',
    url: FACEBOOK_URL,
  },
  {
    icon: GoogleIcon,
    titleKey: 'socialGoogleTitle',
    handleKey: 'socialGoogleHandle',
    descKey: 'socialGoogleDesc',
    ctaKey: 'socialGoogleCta',
    url: GOOGLE_URL,
  },
  {
    icon: TikTokIcon,
    titleKey: 'socialTtTitle',
    handleKey: 'socialTtHandle',
    descKey: 'socialTtDesc',
    ctaKey: 'socialTtCta',
    url: TIKTOK_URL,
  },
];

export default function SocialSection() {
  const { t } = useLang();

  return (
    <section className="social-section" data-testid="social-section">
      <div className="sm-container">
        <div className="social-header">
          <div className="social-badge">{t.socialBadge}</div>
          <h2 className="social-title">{t.socialTitle}</h2>
          <p className="social-subtitle">{t.socialSubtitle}</p>
        </div>

        <div className="social-grid" data-testid="social-grid">
          {socials.map((s, i) => {
            const Icon = s.icon;
            return (
              <a
                key={i}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
                data-testid={`social-card-${i}`}
              >
                <div className="social-card-top">
                  <Icon />
                  <div>
                    <div className="social-card-name">{t[s.titleKey]}</div>
                    <div className="social-card-handle">{t[s.handleKey]}</div>
                  </div>
                </div>
                <p className="social-card-desc">{t[s.descKey]}</p>
                <span className="social-card-cta">
                  {t[s.ctaKey]} <ExternalIcon />
                </span>
              </a>
            );
          })}
        </div>

        <div className="social-review-banner" data-testid="social-review-banner">
          <div className="social-review-text">
            <h3>{t.socialReviewTitle}</h3>
            <p>{t.socialReviewBody}</p>
          </div>
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="social-review-btn"
            data-testid="social-review-cta"
          >
            <StarIcon /> {t.socialReviewCta} <ExternalIcon />
          </a>
        </div>
      </div>
    </section>
  );
}
